// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__-pfO-","title":"Header_title__1m85P","left":"Header_left__308Uj","clinicName":"Header_clinicName__3XKbz"};